import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import {UserAlertEntityFactory} from '../Entities/factory.js'
import UserAlertsErrorsFactory from '../Errors/factory.js'
import {UserAlertsMappersFactory} from '../Mappers/factory.js'
import {UserAlertsListValueObjectFactory} from '../ValueObjects/factory.js'
import EmptyUserAlertsRepository from './EmptyUserAlertsRepository.js'
import HTTPUserAlertsRepository from './HTTPUserAlertsRepository.js'
class UserAlertsRepositoriesFactory {
  static hTTPUserAlertsRepository = ({config}) =>
    new HTTPUserAlertsRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({
        config
      }),
      fromUserAlertRawDataToUserAlertEntityMapper: UserAlertsMappersFactory.fromUserAlertRawDataToUserAlertEntityMapper(
        {
          config
        }
      ),
      hTTPUserAlertsListResponseToUserAlertsValueObjectMapper:
        UserAlertsMappersFactory.hTTPUserAlertsListResponseToUserAlertsValueObjectMapper({config}),
      hTTPNotificationsToUnseenSavedSearchMatchesMapper:
        UserAlertsMappersFactory.hTTPNotificationsToUnseenSavedSearchMatchesMapper({config}),
      userAlertEntity: UserAlertEntityFactory.userAlertEntity,
      getUserAlertError: UserAlertsErrorsFactory.getUserAlertError,
      getUserAlertsError: UserAlertsErrorsFactory.getUserAlertsError,
      deleteUserAlertsError: UserAlertsErrorsFactory.deleteUserAlertsError,
      updateUserAlertsError: UserAlertsErrorsFactory.updateUserAlertsError,
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      duplicatedUserAlertError: UserAlertsErrorsFactory.duplicatedUserAlertError,
      maxLimitReachedUserAlertError: UserAlertsErrorsFactory.maxLimitReachedUserAlertError,
      searchHasNoFiltersUserAlertError: UserAlertsErrorsFactory.searchHasNoFiltersUserAlertError
    })

  static emptyUserAlertsRepository = () =>
    new EmptyUserAlertsRepository({
      unseenSavedSearchMatchesValueObject: UserAlertsListValueObjectFactory.unseenSavedSearchMatchesValueObject
    })
}

export default UserAlertsRepositoriesFactory
